import {
  // Bloque curtas "Ventura"
  nxkaBaSulu, couraca, latitudeFenix, asMaosDaPulpeira,
  // Bloque curtas "Saudade"
  porqueHojeESabado, elLagoSilente, horaDeMudar, reVolta, procuroT,
  // Bloque curtas "Lembranças"
  oCorpoDeCristo, anastacia, oVeu, submergido,
  // Longametraxes
  hanami, amuleto, aMemoriaDoCheiroDasCoisas,
} from './filmes2026.data'

const eventos2026 = [
  // Bloque curtas "Ventura" - 22/10 - MARCO - 17:30 - XOVES
  {
    id: "bloque-curtas-ventura",
    filmes: [nxkaBaSulu, couraca, latitudeFenix, asMaosDaPulpeira],
    data: "2026-10-22",
    hora: "17:30",
    lugar: "MARCO – Museo de Arte Contemporáneo de Vigo",
    bloque: "Bloque curtas 'Ventura'",
    cor: "green",
  },

  // Longametraxe Cabo Verde - 22/10 - Multicines Norte - 20:00 - XOVES
  {
    id: "longametraxe-caboverde",
    filmes: [hanami],
    data: "2026-10-22",
    hora: "20:00",
    lugar: "Multicines Norte, Vigo",
    bloque: "Cabo Verde",
    cor: "blue",
  },

  // Bloque curtas "Saudade" - 23/10 - MARCO - 17:30 - VENRES
  {
    id: "bloque-curtas-saudade",
    filmes: [porqueHojeESabado, elLagoSilente, horaDeMudar, reVolta, procuroT],
    data: "2026-10-23",
    hora: "17:30",
    lugar: "MARCO – Museo de Arte Contemporáneo de Vigo",
    bloque: "Bloque curtas 'Saudade'",
    cor: "yellow",
  },

  // Longametraxe Brasil - 23/10 - Multicines Norte - 20:00 - VENRES
  {
    id: "longametraxe-brasil",
    filmes: [amuleto],
    data: "2026-10-23",
    hora: "20:00",
    lugar: "Multicines Norte, Vigo",
    bloque: "Brasil",
    cor: "blue",
  },

  // Bloque curtas "Lembranças" - 24/10 - MARCO - 17:30 - SÁBADO
  {
    id: "bloque-curtas-lembrancas",
    filmes: [oCorpoDeCristo, anastacia, oVeu, submergido],
    data: "2026-10-24",
    hora: "17:30",
    lugar: "MARCO – Museo de Arte Contemporáneo de Vigo",
    bloque: "Bloque curtas 'Lembranças'",
    cor: "red",
  },

  // Longametraxe Portugal - 24/10 - Multicines Norte - 20:00 - SÁBADO
  {
    id: "longametraxe-portugal",
    filmes: [aMemoriaDoCheiroDasCoisas],
    data: "2026-10-24",
    hora: "20:00",
    lugar: "Multicines Norte, Vigo",
    bloque: "Portugal / Brasil",
    cor: "blue",
  },
]

export default eventos2026
